import React, { Fragment } from 'react';
import { Top } from './page/Top/index';
import { Route, Routes } from 'react-router-dom';
import { Registration } from './page/Registration';
import { TagRegistration } from './page/TagRegistration';
import { Modal } from './_layout/Modal/index';

function AppRoutes() {

 return(
    <Fragment>
        <Routes>
            <Route
                path="/"
                element={<Top />}
            />
            <Route
                path="/registration"
                element={<Registration />}
            />
            <Route
                path="/tagRegistration"
                element={<TagRegistration />}
            />
        </Routes>
        <Modal />
    </Fragment>

 )

}

export { AppRoutes as Routes };
